import { ContributorProfile, Profile } from "@app/types/Cue";
import bylineDefaultImage from "@assets/defaultImages/byline/default.png";
import { cn } from "@util/helpers";

type BylineImageProps = {
  rootClassName?: string;
  profile?: Profile | ContributorProfile;
  width?: number;
  height?: number;
  backdrop?: string;
};
export default function BylineImage({
  rootClassName,
  profile,
  width = 65,
  height = 65,
  backdrop = "white",
}: BylineImageProps): React.ReactElement {
  const byline_image =
    profile?.content.headshotImage?.[0]?.content.fields["square_320-caas"]
      ?.url || bylineDefaultImage;

  return (
    <img
      className={cn("rounded-full", rootClassName, backdrop)}
      src={byline_image}
      alt={profile?.content.fields.name}
      width={width}
      height={height}
    />
  );
}
